import GroupPermissionGridContainer from 'components/organisms/GroupPermissionGridContainer';
import GroupPermissionTopContainer from 'components/organisms/GroupPermissionTopContainer';
import FilterProvider from 'providers/Filter';
import React from 'react';

const GroupPermissionPresentation = () => {
  return (
    <>
      <FilterProvider>
        <GroupPermissionTopContainer />
        <GroupPermissionGridContainer />
      </FilterProvider>
    </>
  );
};

export default GroupPermissionPresentation;
